module.exports = __webpack_public_path__ + "img/close.6d067127.svg";